import styled from '@emotion/styled';

const Eigth:React.FC<any> = () => {
  const handleApp = () => {
    window.location.href="/subscribe"
  }

  return (
    <Container>
      <BodyImg>
        <Img src="/images/newLanding/home/newPhoto3.png"/>
      </BodyImg>
      {/* <Title className="top">내 감성에 맞는<br/> 단 하나의 앨범<br/>매년 받아보세요</Title>
      <SmallText>
        감각적인 우리집 인테리어에
        <br/> 어울리는 유일한 앨범</SmallText> */}
        {/* <Title className="top">더 찾을 필요 없어요<br/> 감성 앨범의 끝<br/>엄마의 사랑스런 증표</Title>
      <SmallText>
        포티페타 앨범이 있다는 건
        <br/> 센스있는 엄마임을 증명해요</SmallText> */}
      <Title className="top">
        세상에 
        <br />단 하나뿐인 앨범을 
        <br />만들어보세요
      </Title>
      <SmallText>
        내 아이의 첫 순간만을 
        <br/>꾸준히 모아보세요.
      </SmallText>
      <SmallText>
        첫 눈맞춤, 첫 뒤집기, 첫 걸음마...
        <br/>휴대폰에 묻히게 두기에는
        <br/>너무 아깝잖아요.
      </SmallText>
      <MoreButtonWrapper>
        <MoreButton
          onClick={handleApp}
        >더 알아보기</MoreButton>
      </MoreButtonWrapper>
    </Container>
  )
};

export default Eigth;

const Container = styled.div`
  width: 100%;
  /* background-color: #ede3cd; */
  background-color: #FBF7F0;
  /* min-height: 100vh; */
`;

const BodyImg = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  &.top{
    margin: 40px 20px 30px;
  }

  &.bottom {
    margin: 50px 20px 30px;
  }
`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px;
  line-height: 1.4;

  &.top {

  }
`;


const MoreButtonWrapper= styled.div`
  margin: 50px auto 120px;
  width: 40%;
  height: 50px;
`

const MoreButton = styled.button`
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: black;
  background-color: rgb(0,0,0,0);
  border: 1px solid rgb(0,0,0,0.2);
  border-radius: 5px;
`;

